import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("select", {
      class: "form-select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("option", { value: null }, "Typ pozemku", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landTypes, (landType) => {
        return (_openBlock(), _createElementBlock("option", {
          key: landType.value,
          value: landType.value
        }, _toDisplayString(_ctx.capitalizeFirstLetter(landType.label)), 9, _hoisted_1))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.selectedValue]
    ])
  ]))
}